import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  Input,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
  Progress,
} from 'reactstrap';
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import NotificationAlert from 'react-notification-alert';
import MediaDialog from './MediaDialog';
import Dialog from '@mui/material/Dialog';
import { compareAsc, format } from 'date-fns';
import { Delete, Edit } from '@mui/icons-material';
import DeleteModal from './DeleteModal';
import api from '../../Utilities/api';
import DeleteSelected from 'components/NotificationCenter/DeleteSelected';
import { algoliaAppID, algoliaSearchID } from '../../Utilities/algoliaKeys';
import algoliasearch from 'algoliasearch/lite';
import SearchIcon from '@mui/icons-material/Search';

function MediaCenter() {
  const [IsEditExpiry, setIsEditExpiry] = useState({ itemId: '', isEdit: false });
  const [expiryDate, setExpiryDate] = useState('');
  const [progressVisible, setProgressVisible] = useState(true);
  const [progressValue, setProgressValue] = useState(8);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [active, setactive] = useState(false);
  const [mediaData, setMediaData] = useState([]);
  const [currentData, setCurrentData] = useState('');
  const [fileName, setFileName] = useState(null);
  const [allCheckedActive, setAllCheckedActive] = useState(false);
  const [allCheckedHistory, setAllCheckedHistory] = useState(false);
  const [isAllDeleteModalVisible, setIsAllDeleteModalVisible] = useState(false);
  const [selectedActive, setSelectedActive] = useState(false);
  const [selectedActiveArr, setSelectedActiveArr] = useState([]);
  const [selectedHistory, setSelectedHistory] = useState(false);
  const [selectedHistoryArr, setSelectedHistoryArr] = useState([]);
  const [mediaSearchValue, setMediaSearchValue] = useState('');
  const [mediaHistorySearchValue, setMediaHistorySearchValue] = useState('');
  const searchClient = algoliasearch(algoliaAppID, algoliaSearchID);
  const [fetchSubject, setFetchSubject] = useState([{ id: '', name: '' }]);
  const mediaSearchIndex = searchClient.initIndex('MediaCenter_Search');

  const notifi = useRef();
  const notify = (msg, err) => {
    // console.log('notify')
    let color = err == false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
  };

  const getActiveLink = () => {
    document.querySelector('#loading-indicator').style.display = 'flex';
    db.collection('MediaCenter')
      .orderBy('createdAt', 'desc')
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => doc.data());
        data = data.map((item) => {
          return { ...item, select: false };
        });
        console.log("MediaCenter1", data);
        setMediaData(data);
        setProgressVisible(false);
        document.querySelector('#loading-indicator').style.display = 'none';
      });
  };

  const deleteFile = (fileName) => {
    if (!fileName) return;
    let fileData = fileName.split('/');

    const data = {
      filename: fileData[1],
    };

    api({ path: '/upload/deleteFile', data: data })
      .then((res) => {
        console.log('Media delete', res?.data?.file);
      })
      .catch((err) => {
        console.log('Media Error', err);
      });
  };

  const changeExpiry = async (expiryDate, itemId) => {
    try {
      await db.collection("MediaCenter").doc(itemId).update({
        expiryDate: expiryDate,
      });
      setIsEditExpiry({ itemId: '', isEdit: false });
      getActiveLink()
    } catch (error) {
      console.log(error);
    }
  }
  const getSubjectDetail = () => {
    db.collection('subjects')
      .where('primaryLanguages', '!=', null) // Ensures primaryLanguages is not null
      .where('status', '==', 0)
      .get()
      .then((querySnapshot) => {
        const subjects = [];
        querySnapshot.forEach((doc) => {
          subjects.push({ id: doc.id, name: doc.data().name });
        });
        setFetchSubject(subjects);
      })
      .catch((error) => {
        console.error('Error fetching subjects: ', error);
      });
  };

  const fetchSubjectNamebyId = (subjectId) => {
    try {
      if (!subjectId) return 'NA'
      const subjectData = fetchSubject?.find(val => val.id == subjectId);
      console.log(subjectData, 'subjectData');
      return subjectData.name
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    getSubjectDetail()
  }, [])

  useEffect(() => {
    if (!isModalVisible) setProgressValue(99);
    getActiveLink();
  }, [isModalVisible]);

  const deleteMedia = () => {
    deleteFile(fileName);
    db.collection('MediaCenter')
      .doc(currentData)
      .delete()
      .then((res) => {
        setMediaData((prev) =>
          prev.filter((item) => item.itemID !== currentData)
        );
        setIsDeleteModalVisible(false);
      })
      .catch((err) => {
        console.log(err);
        setIsDeleteModalVisible(false);
      });
  };

  // on delete Exicuted Code
  const deleteSelectedMedia = () => {
    console.log("Deleting selected media...");
    console.log(
      "active:", active,
      "selectedActive ==>", selectedActive,
      "selectedHistory ==>", selectedHistory,
      "selectedActiveArr ==>", selectedActiveArr,
      "selectedHistoryArr ==>", selectedHistoryArr
    );

    let selectedId = [];

    if (selectedActive) {
      // Delete all active items
      selectedId = mediaData
        .filter(item => compareAsc(new Date(item.expiryDate), new Date()) !== -1)
        .map(item => item.itemID);
    }
    else if (selectedHistory) {
      // Delete all history items
      selectedId = mediaData
        .filter(item => compareAsc(new Date(item.expiryDate), new Date()) === -1)
        .map(item => item.itemID);
    }
    else {
      // If neither is true, delete only selected items from selectedActiveArr and selectedHistoryArr
      selectedId = [...selectedActiveArr.map(item => item.id), ...selectedHistoryArr.map(item => item.id)];
    }

    if (selectedId.length === 0) {
      console.log("No items selected for deletion.");
      return;
    }
    console.log(selectedId);

    let batch = db.batch();
    selectedId.forEach(id => {
      batch.delete(db.collection('MediaCenter').doc(id));
    });

    batch.commit()
      .then(() => {
        setMediaData(prev => prev.filter(item => !selectedId.includes(item.itemID)));
        setIsAllDeleteModalVisible(false);
        notify('Selected items deleted successfully', false);
      })
      .catch(err => {
        console.error("Error deleting media:", err);
        notify(err.message.toString(), false);
      });
  };


  const packageSearch = () => {
    console.log(mediaSearchValue);
    if (mediaSearchValue == '' && mediaHistorySearchValue == '') {
      notify('Search field can not be empty', true);
    } else {
      document.querySelector('#loading-indicator').style.display = 'flex';

      mediaSearchIndex.search(mediaSearchValue || mediaHistorySearchValue, { typoTolerance: false })
        .then((result) => {
          console.log(result,"result");
          if (result.hits.length === 0) {
            document.querySelector('#loading-indicator').style.display = 'none';

            notify('No results found', true);
          } else {
            document.querySelector('#loading-indicator').style.display = 'none';

            setMediaData(result.hits);
            // setReload(true);
          }
        })
        .catch((err) => {
          console.log(err);
          if (document.querySelector('#loading-indicator') !== null)
            document.querySelector('#loading-indicator').style.display = 'none';
          notify(err.toString(), true);
        });
    }
  };

  const emptyCall = () => {
    getActiveLink();
  };

  return (
    <>
      {progressVisible ? (
        <Progress color='info' value={progressValue} style={{ height: 4 }} />
      ) : (
        <div className='content'>
          <div className='react-notification-alert-container'>
            <NotificationAlert ref={notifi} />
          </div>
          <Modal
            isOpen={isDeleteModalVisible}
            color='primary'
            style={{
              display: 'flex',
              flex: 1,
              top: -40,
              width: 250,
              backgroundColor: '#132639',
              objectFit: 'fill',
            }}
          >
            <ModalBody size='sm'>
              <DeleteModal
                setIsDeleteModalVisible={setIsDeleteModalVisible}
                deleteMedia={deleteMedia}
              />
            </ModalBody>
          </Modal>
          <Modal
            isOpen={isAllDeleteModalVisible}
            color='primary'
            style={{
              display: 'flex',
              flex: 1,
              top: -40,
              width: 350,
              backgroundColor: '#132639',
              objectFit: 'fill',
            }}
          >
            <ModalBody size='sm' style={{ textAlign: 'center' }}>
              <DeleteSelected
                setIsAllDeleteModalVisible={setIsAllDeleteModalVisible}
                deleteSelected={deleteSelectedMedia}
              />
            </ModalBody>
          </Modal>
          <Dialog fullScreen open={isModalVisible} onClose={setIsModalVisible}>
            <MediaDialog
              fetchSubject={fetchSubject}
              notify={notify}
              currentData={currentData}
              handleClose={setIsModalVisible}
              setMediaData={setMediaData}
            />
          </Dialog>

          <Row>
            <Col>
              <Card>
                <CardHeader
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Col>
                    <ButtonGroup>
                      <Button
                        className={active ? 'data' : 'btn-simple data'}
                        color='info'
                        size='sm'
                        onClick={() => {
                          setactive((prev) => !prev);
                          setSelectedHistoryArr([])
                          setSelectedActiveArr([])
                          setSelectedActive(false)
                          setSelectedHistory(false)
                          setMediaHistorySearchValue('');
                          getActiveLink();
                          setAllCheckedActive(false);
                          setAllCheckedHistory(false);
                        }}
                      >
                        <span className='d-none d-sm-block d-md-block d-lg-block d-xl-block'>
                          Active
                        </span>
                        <span className='d-block d-sm-none'>
                          <i className='tim-icons icon-single-02' />
                        </span>
                      </Button>
                      <Button
                        className={active ? 'btn-simple data' : 'data'}
                        color='info'
                        size='sm'
                        onClick={() => {
                          setSelectedHistoryArr([])
                          setSelectedActiveArr([])
                          setSelectedActive(false)
                          setSelectedHistory(false)
                          setactive((prev) => !prev);
                          getActiveLink();
                          setMediaSearchValue('');
                        }}
                      >
                        <span className='d-none d-sm-block d-md-block d-lg-block d-xl-block'>
                          History
                        </span>
                        <span className='d-block d-sm-none'>
                          <i className='tim-icons icon-single-02' />
                        </span>
                      </Button>
                    </ButtonGroup>
                  </Col>
                  {active ? (
                    <Button
                      color='info'
                      onClick={() => (
                        setIsModalVisible(true), setCurrentData('')
                      )}
                    >
                      Add New
                    </Button>
                  ) : null}
                  {console.log(
                    "selectedActive ==>", selectedActive,
                    "selectedHistory ==>", selectedHistory,
                    "selectedActiveArr ==>", selectedActiveArr,
                    "selectedHistoryArr ==>", selectedHistoryArr
                  )}
                  {selectedActive ||
                    selectedHistory ||
                    selectedActiveArr.length > 1 ||
                    selectedHistoryArr.length > 1 ? (
                    <Col style={{ paddingRight: '0px', paddingTop: 5 }} sm={1}>
                      <Button
                        style={{ margin: '0px', padding: '6px 10px' }}
                        color='danger'
                        // onClick={() => {
                        //   console.log(
                        //     "selectedActive ==>", selectedActive,
                        //     "selectedHistory ==>", selectedHistory,
                        //     "selectedActiveArr ==>", selectedActiveArr,
                        //     "selectedHistoryArr ==>", selectedHistoryArr
                        //   )
                        // }}
                      onClick={() => setIsAllDeleteModalVisible(true)}
                      >
                        <Delete />
                      </Button>
                    </Col>
                  ) : null}
                </CardHeader>
                {active ? (
                  <>
                    <CardBody>
                      <Row>

                        <Col sm={4}>

                          <Input
                            type='text'
                            name='searchInvoice'
                            placeholder='Search media'
                            value={mediaSearchValue}
                            onInput={(e) => {
                              setMediaSearchValue(e.target.value);
                              e.target.value.length === 0 && emptyCall();
                            }}
                          />

                        </Col>

                        <Col style={{ paddingLeft: '0px' }} sm={2}>
                          <Button
                            style={{ margin: '0px', padding: '6px 10px' }}
                            color='info'
                            onClick={packageSearch}
                          >
                            <SearchIcon />
                          </Button>
                        </Col>
                      </Row>
                      {mediaData.some((item) => compareAsc(new Date(item.expiryDate), new Date()) === 1) ?
                        <Table>
                          <thead className='text-primary'>
                            <tr>
                              {mediaData.length !== 0 && (
                                <th>
                                  <input
                                    type='checkbox'
                                    checked={allCheckedActive}
                                    onChange={(e) => {
                                      let checked = e.target.checked;
                                      setSelectedHistoryArr([])
                                      if (checked == true) {
                                        setSelectedActive(true);
                                        setSelectedActiveArr(mediaData
                                          .filter(item => compareAsc(new Date(item.expiryDate), new Date()) === 1)
                                          .map(item => { return { id: item.itemID } }));
                                      } else {
                                        setSelectedActive(false);
                                        setSelectedActiveArr([]);
                                      }
                                      let checkedData = mediaData.map((data) => {
                                        data.select = checked;
                                        return data;
                                      });
                                      setAllCheckedActive(checked);
                                      setMediaData(checkedData);
                                    }}
                                  />
                                </th>
                              )}
                              <th style={{ textAlign: 'left', width: '30%' }}>
                                Topic Name
                              </th>
                              <th style={{ textAlign: 'left' }}>Subject</th>
                              <th style={{ textAlign: 'left' }}>Lecture Date</th>
                              <th style={{ textAlign: 'left' }}>Expiry Date</th>
                              <th style={{ textAlign: 'left' }}>Batches</th>
                              <th style={{ textAlign: 'center' }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {mediaData.length === 0 && (
                              <tr>
                                <td></td>
                                <td></td>
                                <td>No Data Found</td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                            {mediaData.map((item) => {
                              let batchdetails = item.batch;
                              let result = compareAsc(
                                new Date(item.expiryDate),
                                new Date()
                              );
                              return result === 1 ? (
                                <tr key={item.itemID}>
                                  <td>
                                    <input
                                      type='checkbox'
                                      checked={item.select}
                                      onChange={(e) => {
                                        let checked = e.target.checked;
                                        let updatedSelectedArr = [];
                                        setSelectedHistoryArr([])
                                        setMediaData(
                                          mediaData.map((data) => {
                                            if (item.itemID === data.itemID) {
                                              data.select = checked;
                                              if (checked) {
                                                updatedSelectedArr = [...selectedActiveArr, { id: item.itemID }];
                                                setSelectedActiveArr((prev) => [
                                                  { id: item.itemID },
                                                  ...prev,
                                                ]);
                                              } else {
                                                updatedSelectedArr = selectedActiveArr
                                                  .filter((dataId) =>
                                                    dataId.id !== item.itemID
                                                  );
                                                setSelectedActiveArr(updatedSelectedArr);
                                              }
                                            }
                                            console.log('check exicuted', e.target.checked);

                                            if (e.target.checked == false) {
                                              console.log(
                                                "allCheck False exicuted"
                                              );
                                              setSelectedActive(false);
                                              setAllCheckedActive(false);
                                            }

                                            if (e.target.checked) {
                                              console.log("allCheck true exicuted", mediaData.length, updatedSelectedArr.length);

                                              if (mediaData.length == updatedSelectedArr.length) {
                                                setAllCheckedActive(true);
                                              }
                                            }
                                            return data;
                                          })
                                        );
                                      }}
                                    />
                                  </td>
                                  <td>{item.title}</td>
                                  <td>{fetchSubjectNamebyId(item?.subjectId)}</td>

                                  <td style={{ textAlign: 'left' }}>
                                    {item?.lectureDate &&
                                      format(
                                        new Date(item.lectureDate),
                                        'dd/MM/yyyy'
                                      )}
                                  </td>
                                  <td style={{ textAlign: 'left' }}>
                                    {format(
                                      new Date(item.expiryDate),
                                      'dd/MM/yy hh:mm aa'
                                    )}
                                  </td>

                                  <td style={{ textAlign: 'left' }}>
                                    {batchdetails.map((data, index) => {
                                      return (
                                        <li key={index}>{data.batchName}</li>
                                      );
                                    })}
                                  </td>
                                  <td
                                    style={{
                                      cursor: 'pointer',
                                      textAlign: 'center',
                                    }}
                                  >
                                    <Edit
                                      style={{ color: '#247cf7' }}
                                      onClick={() => {
                                        setCurrentData(item);
                                        setIsModalVisible(true);
                                      }}
                                    />
                                    <Delete
                                      onClick={() => {
                                        setCurrentData(item.itemID);
                                        setIsDeleteModalVisible(true);
                                        setFileName(item?.fileUrl);
                                      }}
                                      style={{ color: 'red' }}
                                    />
                                  </td>
                                </tr>
                              ) : null;
                            })}
                          </tbody>
                        </Table> : <div
                          style={{
                            textAlign: 'center',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            padding: '20px',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            marginTop: '20px',
                          }}
                        >
                          No Data Found
                        </div>
                      }
                    </CardBody>
                  </>
                ) : (
                  <>
                    <CardBody>
                      <Row>
                        <Col sm={4}>
                          <Input
                            type='text'
                            name='searchHistory'
                            placeholder='Search media'
                            value={mediaHistorySearchValue}
                            onInput={(e) => {
                              setMediaHistorySearchValue(e.target.value);
                              e.target.value.length === 0 && emptyCall();
                            }}
                          />
                        </Col>
                        <Col style={{ paddingLeft: '0px' }} sm={2}>
                          <Button
                            style={{ margin: '0px', padding: '6px 10px' }}
                            color='info'
                            onClick={packageSearch}
                          >
                            <SearchIcon />
                          </Button>
                        </Col>
                      </Row>
                      {mediaData.some((item) => compareAsc(new Date(item.expiryDate), new Date()) === -1) ?
                        <Table>
                          <thead className='text-primary'>
                            <tr>
                              {mediaData.length !== 0 && (
                                <th>
                                  <input
                                    type='checkbox'
                                    checked={allCheckedHistory}
                                    onChange={(e) => {
                                      let checked = e.target.checked;
                                       setSelectedActiveArr([]);
                                      if (checked == true) {
                                        setSelectedHistory(true);
                                        setSelectedHistoryArr(mediaData
                                          .filter(item => compareAsc(new Date(item.expiryDate), new Date()) === -1)
                                          .map(item =>{return{id:item.itemID}}))
                                      } else {
                                        setSelectedHistory(false);
                                        setSelectedHistoryArr([]);
                                      }
                                      let checkedData = mediaData.map((data) => {
                                        data.select = checked;
                                        return data;
                                      });
                                      setAllCheckedHistory(checked);
                                      setMediaData(checkedData);
                                    }}
                                  />
                                </th>
                              )}
                              <th style={{ textAlign: 'left', width: '30%' }}>
                                Topic Name
                              </th>
                              <th style={{ textAlign: 'left' }}>Subject</th>
                              <th style={{ textAlign: 'left' }}>Lecture date</th>
                              <th style={{ textAlign: 'left' }}>Expiry Date check</th>
                              <th style={{ textAlign: 'left' }}>Batches</th>
                              <th style={{ textAlign: 'center' }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {mediaData.length === 0 && (
                              <tr>
                                <td></td>
                                <td></td>
                                <td>No Data Found</td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                            {mediaData.map((item, index) => {
                              let batchdetails = item.batch;
                              // console.log("yahi h:",item?.lectureDate);
                              let result = compareAsc(
                                new Date(item.expiryDate),
                                new Date()
                              );
                              return result === -1 ? (
                                <>
                                  <tr key={index}>
                                    <td>
                                      <input
                                        type='checkbox'
                                        checked={item.select}
                                        onChange={(e) => {
                                          let checked = e.target.checked;
                                          let updatedSelectedArr = [];
                                          setMediaData(
                                            mediaData.map((data) => {
                                              if (item.itemID === data.itemID) {
                                                data.select = checked;
                                                setSelectedActiveArr([])
                                                if (checked) {
                                                  updatedSelectedArr = [...selectedHistoryArr, { id: item.itemID }]
                                                  setSelectedHistoryArr(updatedSelectedArr);
                                                } else {
                                                  updatedSelectedArr = selectedHistoryArr
                                                    .filter((dataId) =>
                                                      dataId.id !== item.itemID
                                                    );
                                                  setSelectedHistoryArr(updatedSelectedArr);
                                                }
                                              }
                                              if (e.target.checked == false) {
                                                setSelectedHistory(false)
                                                setAllCheckedHistory(false);
                                              }
                                              if (e.target.checked) {
                                                console.log("allCheck true exicuted", mediaData.length, updatedSelectedArr.length);

                                                if (mediaData.length == updatedSelectedArr.length) {
                                                  // setAllCheckedActive(true);
                                                  setAllCheckedHistory(true)
                                                }
                                              }
                                              return data;
                                            })
                                          );
                                        }}
                                      />
                                    </td>
                                    <td>{item.title}</td>
                                    <td>{fetchSubjectNamebyId(item?.subjectId)}</td>
                                    <td style={{ textAlign: 'left' }}>
                                      {item?.lectureDate &&
                                        format(
                                          new Date(item.lectureDate),
                                          'dd/MM/yyyy'
                                        )}
                                    </td>

                                    <td style={{ textAlign: 'left' }}>
                                      {console.log('ccheckingNew', IsEditExpiry)}
                                      {IsEditExpiry.isEdit == true && IsEditExpiry.itemId == item.itemID ?
                                        <div style={{ display: 'flex', justifyContent: 'center', width: '170px', alignItems: 'center' }}>
                                          <input
                                            className='form-control'
                                            type='datetime-local'
                                            name='expiryDate'
                                            value={expiryDate || item.expiryDate}
                                            onChange={(e) => {
                                              setExpiryDate(e.currentTarget.value)
                                              // changeExpiry(e.currentTarget.value,item.itemID)
                                              console.log(e.currentTarget.value);
                                            }}
                                          /><TaskAltIcon style={{ marginLeft: '5px', color: '#247cf7', cursor: 'pointer' }} onClick={() => {
                                            changeExpiry(expiryDate, item.itemID)
                                          }} />

                                        </div> :
                                        <div style={{ display: 'flex', justifyContent: 'center', width: '170px', alignItems: 'center' }}>

                                          {format(
                                            new Date(item.expiryDate),
                                            'dd/MM/yy hh:mm aa'
                                          )}
                                          <Edit
                                            style={{ color: '#247cf7', marginLeft: '10px', cursor: 'pointer' }}
                                            onClick={() => {
                                              setIsEditExpiry({ itemId: item.itemID, isEdit: true })
                                              console.log('edit Enable');
                                            }}
                                          />

                                        </div>}
                                    </td>

                                    <td style={{ textAlign: 'left' }}>
                                      {batchdetails.map((data, index) => {
                                        return (
                                          <li key={index}>{data.batchName}</li>
                                        );
                                      })}
                                    </td>
                                    <td
                                      style={{
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <Delete
                                        onClick={() => {
                                          setCurrentData(item.itemID);
                                          setIsDeleteModalVisible(true);
                                          setFileName(item?.fileUrl);
                                        }}
                                        style={{ color: 'red' }}
                                      />
                                    </td>
                                  </tr>
                                </>
                              ) : null
                            })}

                          </tbody>
                        </Table> : <div
                          style={{
                            textAlign: 'center',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            padding: '20px',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            marginTop: '20px',
                          }}
                        >
                          No Data Found

                        </div>
                      }
                    </CardBody>
                  </>
                )}
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}

export default MediaCenter;
